<template>
  <!--
    作者：luoyiming
    时间：2020-06-04
    描述：插件中心-直播
  -->
  <div>
    <!--直播房间-->
    <Room v-if="activeName == 'room'"></Room>
    <Order v-if="activeName == 'order'"></Order>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Room from './room/room.vue';
import Order from './order/list.vue';

export default {
  components: {
    Room,
    Order
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'room',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'room',
          value: '直播房间',
        },
        {
          key: 'order',
          value: '直播订单',
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.sourceList;//this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'live'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'live', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/live/index.vue